// extracted by mini-css-extract-plugin
module.exports = {"container":"CaptchaFieldView_container__1RJTb"};